export function fmtEUR(v) {
  const n = Number(v || 0);
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(n);
}

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Intl.DateTimeFormat("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" })
      .format(new Date(d));
  } catch {
    return String(d);
  }
}

export function fmtDateTime(d) {
  if (!d) return "—";
  try {
    return new Intl.DateTimeFormat("de-DE", {
      day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
    }).format(new Date(d));
  } catch {
    return String(d);
  }
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]).join("").toUpperCase();
}
